import { controls, currencyToNumber, grouped } from "../../controls";

const rpdrp1 = {
  label: "Performa 1",
  starting: true,
  url: "rp101m",
  pageLabel: "Performa 1",
  pageType: "history",
  visitingBranches: true,
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "Bank" }),
    ...controls.oc({ tab: "filter", c: "Bank", placeHolder: "Bank Code", name: "bank_code", defaultValue: "assigned_bank", fastpath: "banks" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "bank_display" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Performa 1",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      fields: ["year1", "year2", "year3", "total", "total_loan", "npa"],
      location: "top",
      subtotals: {
        by: "manual_report_type",
        displayIn: "observation"
      },
      grandtotal: { type: "fixed", displayIn: "observation", val: "Grand Total", count: true },
    },
    pivotable: true,
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Observation",
        accessor: "observation",
        rwidth: "*"
      },
      {
        Header: "2019-2020",
        accessor: "year1",
        type: 'currency'
      },
      {
        Header: "2020-2021",
        accessor: "year2",
        type: 'currency'
      },
      {
        Header: "2021-2022",
        accessor: "year3",
        type: 'currency'
      },
      {
        Header: "TOTAL",
        accessor: "total",
        formula: [{
          f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'year1' }, { source: 'row', field: 'year2' }, { source: 'row', field: 'year2' }
          ], resultVar: 'total'
        }],
        type: 'currency'
      },
      {
        Header: "O/S on 31-03-2022",
        accessor: "total_loan",
        type: 'currency'
      },
      {
        Header: "NPA for loans issued during 01/04/19-31/03/22",
        accessor: "npa",
        type: 'currency'
      }
    ]
  }
};

export default rpdrp1;